/**
 * Global error handler that silently catches property access errors
 * Returns empty strings instead of crashing the page
 */

export default defineNuxtPlugin(() => {
  // Override global error handler
  window.addEventListener('error', (event) => {
    const error = event.error
    
    // Check if this is a property access error
    if (error && error.message && (
      error.message.includes('Cannot read propert') ||
      error.message.includes('Cannot access before initialization') ||
      error.message.includes('is undefined') ||
      error.message.includes('is null')
    )) {
      // Log in development only
      if (process.dev) {
        console.warn('[Silent Error Handler]:', error.message)
      }
      
      // Prevent the error from showing to user
      event.preventDefault()
      return false
    }
  })
  
  // Vue error handler for template errors
  const nuxtApp = useNuxtApp()
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    // Check if this is a property access error in templates
    if (error && error.message && (
      error.message.includes('Cannot read propert') ||
      error.message.includes('Cannot access before initialization') ||
      error.message.includes('is undefined') ||
      error.message.includes('is null')
    )) {
      // Log in development only
      if (process.dev) {
        console.warn('[Vue Error Handler]:', error.message, 'in', info)
      }
      
      // Return false to prevent default error handling
      return false
    }
    
    // Let other errors propagate normally
    throw error
  }
})